var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1123 12.375V13.95",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3623 16.5H12.8623V15.75C12.8623 14.925 12.1873 14.25 11.3623 14.25H6.8623C6.0373 14.25 5.3623 14.925 5.3623 15.75V16.5V16.5Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6123 16.5H13.6123",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12C6.0975 12 3.75 9.6525 3.75 6.75V4.5C3.75 2.8425 5.0925 1.5 6.75 1.5H11.25C12.9075 1.5 14.25 2.8425 14.25 4.5V6.75C14.25 9.6525 11.9025 12 9 12Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10228 8.73745C3.53978 8.55745 3.04479 8.22745 2.65479 7.83745C1.97979 7.08745 1.52979 6.18745 1.52979 5.13745C1.52979 4.08745 2.35479 3.26245 3.40479 3.26245H3.89229C3.74229 3.60745 3.66728 3.98995 3.66728 4.38745V6.63745C3.66728 7.38745 3.82478 8.09245 4.10228 8.73745Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8975 8.73745C14.46 8.55745 14.955 8.22745 15.345 7.83745C16.02 7.08745 16.47 6.18745 16.47 5.13745C16.47 4.08745 15.645 3.26245 14.595 3.26245H14.1075C14.2575 3.60745 14.3325 3.98995 14.3325 4.38745V6.63745C14.3325 7.38745 14.175 8.09245 13.8975 8.73745Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.2f2537f0.svg";
export { ForwardRef as ReactComponent };